import App from 'app/app.js';
import 'app/directive/LtSoftMatchFormCtrl.js';

function LtSoftMatchFormDirective() {
  return {
    restrict: 'E',
    scope: {
      models: '='
    },
    template:
      '<div class="row"> ' +
      '    <div class="col-xs-12 form"> ' +
      '        <ul> ' +
      '           <li> ' +
      '               <input type="text" ng-model="ctrl.firstName"' +
      ' placeholder="{{ctrl.getPlaceholder(\'SOFT_MATCH_FIRST_NAME_PLACEHOLDER\')}}"' +
      ' name="firstName"' +
      ' required lt-key-filter="name" maxlength="16"> ' +
      '           </li> ' +
      '           <li> ' +
      '               <input type="text" ng-model="ctrl.lastName"' +
      ' placeholder="{{ctrl.getPlaceholder(\'SOFT_MATCH_LAST_NAME_PLACEHOLDER\')}}"' +
      ' name="lastName"' +
      ' required lt-key-filter="name" maxlength="16"> ' +
      '           </li> ' +
      '           <li> ' +
      '               <div class="styled-select"> ' +
      '                   <select ng-model="ctrl.grade" ng-options="grade as ((\'GRADE_\' + grade) | ContentFilter) for grade in models.grades" name="grade" required> ' +
      '                       <option value="" lt-translate="SOFT_MATCH_GRADE_PLACEHOLDER"></option> ' +
      '                   </select> ' +
      '               </div> ' +
      '            </li> ' +
      '        </ul> ' +
      '    </div> ' +
      '</div> ',
    controller: 'LtSoftMatchFormCtrl',
    controllerAs: 'ctrl',
    link: function (scope, element, attrs, ctrl) {
      ctrl.setFirstName(scope.models.firstName);

      scope.models.getFirstName = function () {
        return ctrl.getFirstName();
      };

      ctrl.getPlaceholder = function (key) {
        return $filter('ltTranslateFilter')(key);
      };

      ctrl.setLastName(scope.models.lastName);

      scope.models.getLastName = function () {
        return ctrl.getLastName();
      };

      ctrl.setGrade(scope.models.grade);

      scope.models.getGrade = function () {
        return ctrl.getGrade();
      };
    }
  };
}

App.directive('ltSoftMatchForm', [LtSoftMatchFormDirective]);
